import React, { ReactNode, useMemo } from "react"
import { TabsTab } from './index.style'

interface TabItemType{
    key: string;
    label: string;
    children: ReactNode
    isLink?: boolean
    url?: string
}
interface TabsProps{
    activeKey?: string;
    items: TabItemType[];
    onChange?: (activeKey: string) => void;
}

const Tabs: React.FC<TabsProps> = (props)=>{
    const TabsContent = useMemo(()=>{
        return props.items.find(v=>v.key === props.activeKey)
    }, [props.activeKey, props.items])
    return (
        <div className="flex">
            <div className="flex shrink-0 flex-col gap-y-4 flex-none pr-4">
                {props.items.map(v=>(
                    <TabsTab key={v.key} className={`${v.key === props.activeKey ? 'tabs_tab_active' : ''}`} onClick={() => props.onChange?.(v.key)}>
                        <div className="tabs-tab-btn" key={v.key}>{v.label}</div>
                    </TabsTab>
                    
                ))}
            </div>
            <div className="flex-1 overflow-x-auto pl-4 border-0 border-l border-solid border-[#f0f0f0]">
                {TabsContent?.children}
            </div>
        </div>
    )
}
export default Tabs